import React, { useState, useCallback, useEffect, useReducer} from 'react'
import { StyleSheet, Text, View, ActivityIndicator, Button, Alert, Platform } from 'react-native'
import BottomLogo from '../components/BottomLogo';
import Card from '../components/Card';
import Input from '../components/Input';
import { useDispatch } from 'react-redux';
import { StatusBar } from 'expo-status-bar';
import * as authActions from '../store/authActions'

const FORM_INPUT_UPDATE = 'FORM_INPUT_UPDATE';

const formReducer = (state, action) => {
    if (action.type === FORM_INPUT_UPDATE) {
      const updatedValues = {
        ...state.inputValues,
        [action.input]: action.value
      };
      const updatedValidities = {
        ...state.inputValidities,
        [action.input]: action.isValid
      };
      let updatedFormIsValid = true;
      for (const key in updatedValidities) {
        updatedFormIsValid = updatedFormIsValid && updatedValidities[key];
      }
      return {
        formIsValid: updatedFormIsValid,
        inputValidities: updatedValidities,
        inputValues: updatedValues
      };
    }
    return state;
  };

const ResetPasswordScreen = props => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [webSucces, setWebSucces] = useState(false);
    const dispatch = useDispatch();

    const [formState, dispatchFormState] = useReducer(formReducer, {
        inputValues: {
          email: '',
        },
        inputValidities: {
          email: false,
        },
        formIsValid: false
    });


    const resetHandler = useCallback(async () => {
        if (!formState.formIsValid) {
          Alert.alert('Wrong input!', 'Please check the entries', [
            { text: 'OK'}
          ]);
          return;
        }
        setError(null);
        setIsLoading(true);
        try {
            await dispatch(authActions.resetPassword(formState.inputValues.email));
            Alert.alert('Succes', 'A reset email has been sent. Please check your inbox', [{text: 'Ok' }])
            if(Platform.OS === 'web'){
              setWebSucces(true);
            }
            // nicer error handling
        } catch (err) {
          setError(err.message)
          setIsLoading(false)
        }
        setIsLoading(false)
    }, [dispatch, formState])

   
   
    const inputChangeHandler = useCallback((inputIdentifier, inputValue, inputValidity) => {
        dispatchFormState({
          type: FORM_INPUT_UPDATE,
          value: inputValue,
          isValid: inputValidity,
          input: inputIdentifier
        });
      },
      [dispatchFormState]
    );


    return (
        <View style={styles.screen}>
          <StatusBar style="auto" />
            <View style={styles.titleContainer}><Text style={styles.title}>Reset Password</Text></ View>
            {error && <Card style={styles.errorContainer}>
                 <Text style={styles.errorText}>{error}</Text>
            </Card>}
            {webSucces &&<View style={{marginTop: 10}}>
                   <Text style={styles.succesText}>A reset email has been sent. Please check your inbox</Text>
            </View>}
            <Card style={styles.card}>
                <Input
                    id="email"
                    label="Enter your email address to reset your password"
                    errorText="Please enter a valid email address"
                    keyboardType="email-address"
                    autoCapitalize="none"
                    autoCorrect={false}
                    returnKeyType="done"
                    textContentType="emailAddress"
                    onInputChange={inputChangeHandler}
                    required
                    email
                    placeholder="Email"
                    onSubmitEditing={resetHandler}
                />
                <View style={styles.buttonContainer}>
                    {isLoading 
                    ? <ActivityIndicator size='small' color='#404040' /> 
                    :<Button style={{margin: 10}} title="Reset" color='#404040' onPress={resetHandler} />}
                </View>
            </Card>
            <BottomLogo style={{marginTop: 50}} />
        </View>
    )
}

export default ResetPasswordScreen

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        alignItems: 'center',
    },
    title: {
        fontSize: 32,
        fontWeight: "bold"
    },
    titleContainer: {
        width: '100%',
        alignItems: 'center',
        padding: 10,
        marginBottom: 10,
    },
    card: {
        width: '85%',
        paddingHorizontal: 20,
        maxWidth: 500
    },
    buttonContainer: {
        width: '100%',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginBottom: 10
    },
    errorContainer: {
      width: '85%',
      padding: 5,
      marginBottom: 10,
      alignItems: 'center',
      maxWidth: 500
    },
    errorText: {
      color: '#d9534f',
      fontSize: 13,
    },
    succesText: {
      color: '#0275d8',
      fontSize: 14
    },
})
